function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Artboard");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(5.500000, 10.500000) rotate(270.000000) translate(-5.500000, -10.500000) translate(-5.000000, 5.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(6.000000, 5.347123) rotate(41.000000) translate(-6.000000, -5.347123) ",
  x: -1,
  y: 4.34712278,
  width: 14,
  height: 2
}), React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(14.939026, 5.347123) scale(-1, 1) rotate(41.000000) translate(-14.939026, -5.347123) ",
  x: 7.93902609,
  y: 4.34712278,
  width: 14,
  height: 2
})));

var SvgRightArrowHead = function SvgRightArrowHead(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "21px",
    viewBox: "0 0 11 21",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRightArrowHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-arrow-head.11be2b16.svg";
export { ForwardRef as ReactComponent };